import { useContextStore } from './contextStore';
import { useCookiesStore, CookiesState } from './cookieStore';
import { useDocumentsStore } from './documentsStore';

export const initializeSubscriptions = () => {
  useCookiesStore.subscribe((state: CookiesState, prevState: CookiesState) => {
    if (
      state.marketingCookiesAccepted !== prevState.marketingCookiesAccepted ||
      state.statisticsCookieAccepted !== prevState.statisticsCookieAccepted
    ) {
      useContextStore.getState().fetchContext();
    }
  });

  useContextStore.subscribe((state, prevState) => {
    if (state.activeBpNumber != prevState.activeBpNumber) {
      if (state.activeBpNumber) {
        useDocumentsStore.getState().initializeDocumentsStore();
      } else {
        useDocumentsStore.getState().clearDocumentsStore();
      }
    }
  });
};
